"use client";

import { useTheme } from "../context/ThemeContext";
import dynamic from "next/dynamic";
import {
  TOP_LOADER_APP_DARK,
  TOP_LOADER_APP_LIGHT,
} from "@/src/constants/app-programmatic-theme";

const NextTopLoader = dynamic(() => import("nextjs-toploader"), { ssr: false });

export const ClientTopLoader = () => {
  const { theme } = useTheme();

  return (
    <NextTopLoader
      color={theme === "dark" ? TOP_LOADER_APP_DARK : TOP_LOADER_APP_LIGHT}
    />
  );
};
